import { useState } from 'react';
import { api } from './api';

type CheckoutResponse = {
  sessionId: string;
  url: string;
};

export function useStripeCheckout() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const startCheckout = async (credits: number) => {
    setLoading(true);
    setError(null);
    try {
      const data = await api.post<CheckoutResponse>('/api/stripe/checkout', { credits });
      if (data.url) {
        window.location.href = data.url;
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erro ao iniciar pagamento');
      setLoading(false);
    }
  };

  return { startCheckout, loading, error };
}
